import { render, staticRenderFns } from "./RelatoriosTesteFinalResultsPanel.vue?vue&type=template&id=049a654c&scoped=true&"
import script from "./RelatoriosTesteFinalResultsPanel.vue?vue&type=script&lang=js&"
export * from "./RelatoriosTesteFinalResultsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049a654c",
  null
  
)

export default component.exports